<template>
  <div class="announcement-bar" :class="[ `announcement-bar--${resource.columns.focus}` ]">
    <div class="announcement-bar__container">
      <div class="announcement-bar__left" />
      <div class="announcement-bar__center">
        <span class="announcement-bar__label">
          Aktuelles:
        </span>
        <span class="announcement-bar__title">
          {{ resource.columns.title }}
        </span>
        <nuxt-link :to="resource.url || '/'" class="announcement-bar__link">
          Erfahren Sie mehr
        </nuxt-link>
      </div>
      <div class="announcement-bar__right">
        <CloseIcon class="announcement-bar__icon" @click="handleClose" />
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from 'beisheim/assets/images/icons/beisheim-stiftung-close.svg'

export default {
  components: {
    CloseIcon
  },
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClose () {
      this.$emit('close', this.resource)
    }
  }
}
</script>

<style lang="scss">
  @import "~beisheim/scss/colors";
  @import "~beisheim/scss/font";

  .announcement-bar {
    @include font(-1);
    background-color: gray(4);
    padding: 0.5rem;
    color: #000;

    &--bildung {
      background-color: brand(3);
    }

    &--gesundheit {
      background-color: brand(4);
    }

    &--kultur {
      background-color: brand(1);
    }

    &--sport {
      background-color: brand(2);
    }

    &__container {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__icon {
      user-select: none;
      cursor: pointer;
      width: 0.75rem;
    }

    &__right {
      line-height: 0;
    }

    &__label {
      font-weight: bold;
    }

    &__link {
      text-decoration: underline;
      margin-left: 1rem;
    }
  }
</style>
